// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__2kDFK","dragIcon":"SortableItem_dragIcon__dLJoC","disabled":"SortableItem_disabled__3ywbr"};